// Main schema exports
export * from './constants';
export * from './types';
export * from './generators';
export * from './utils';

// Re-export commonly used functions for convenience
export {
  generateWebSiteSchema,
  generateWebPageSchema,
  generateBreadcrumbListSchema,
  generateSoftwareApplicationSchema,
  generateBlogPostingSchema,
  generateFAQPageSchema,
  generatePageSchemas,
  generateHomepageSchemas
} from './generators';

export {
  SCHEMA_CONTEXT,
  COMPANY_INFO,
  SOFTWARE_APP_INFO,
  COMMON_KEYWORDS
} from './constants';

export {
  createPageSchemaOptions,
  createBlogPostSchemaOptions,
  breadcrumbPatterns,
  keywordSets
} from './utils';
